const Footer = () => {
  return (
    <footer>
      <p>© 2024 Lander Duncan and Martin Angell, No Rights Reserved</p>
    </footer>
  );
};

export default Footer;
